import React, {createContext, useContext, useEffect, useState} from 'react'
import {useGesture} from '@use-gesture/react'
import _ from 'lodash'
import {Button} from 'semantic-ui-react'
import {AuthContext} from '@/features/auth'
import {LabelingContext} from '@/features/labeling'
import {DataSourcesContext, LegacyCatalogContext} from '../data-sources'

export type ICheatsContext = object

export interface ICheatsProps {
  children?: React.ReactNode
}

export interface IViewerProps {
  data: unknown
}

export interface ICheat {
  enabled: boolean
  code: string[]
  func: () => React.ReactNode
}

export interface ICheatMap {
  [key: string]: ICheat
}

export const CheatsContext = createContext<ICheatsContext>({})

export function Cheats(props: ICheatsProps) {
  const {children} = props

  const auth = useContext(AuthContext)
  const catalog = useContext(LegacyCatalogContext)
  const labeling = useContext(LabelingContext)
  const dataSources = useContext(DataSourcesContext)

  const codes: ICheatMap = {
    konami: {
      enabled: true,
      code: [
        'ArrowUp',
        'ArrowUp',
        'ArrowDown',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'ArrowLeft',
        'ArrowRight',
        'KeyB',
        'KeyA',
        'Enter',
      ],
      func: () => {
        console.log({
          auth,
          catalog,
          labeling,
          dataSources,
        })
        return null
      },
    },
  }

  const maxKeyLength = 32
  const [activeCheats, setActiveCheats] = useState<string[]>([])
  const [view, setView] = useState<React.ReactNode>(null)
  const [keyChain, setKeyChain] = useState<string[]>([])

  useEffect(() => {
    if (!(keyChain && keyChain.length > 0)) return
    _.forEach(_.toPairs(codes), ([k, {enabled, code, func}]) => {
      if (!enabled) return
      if (!(code && code.length > 0)) return
      const res = _.chain(keyChain)
        .slice(keyChain.length - code.length, keyChain.length)
        .zip(code)
        .map(([a, b]) => a === b)
        .reduce((a, b) => a && b)
        .value()
      if (!res) return
      setActiveCheats((value) => _.uniq([...(value || []), k]))
      setView(func())
    })
  }, [keyChain])

  useGesture(
    {
      onKeyDown: (e) => {
        const t = e.event.target as HTMLElement | null
        if (!t || t.tagName !== 'BODY') return
        const key = e.event.code
        setKeyChain((prev) =>
          _.chain(prev)
            .concat([key])
            .slice(Math.max(prev.length - maxKeyLength, 0), prev.length + 1)
            .value()
        )
      },
    },
    {
      target: window,
    }
  )

  const contextState = {
    activeCheats: activeCheats,
  }

  if (view)
    return (
      <CheatsContext.Provider value={contextState}>
        <div
          style={{
            position: 'absolute',
            top: '0.25em',
            right: '0.25em',
          }}
        >
          <Button
            compact
            size='tiny'
            icon='close'
            color='red'
            content='Return'
            onClick={() => setView(null)}
          />
        </div>
        {view}
      </CheatsContext.Provider>
    )

  return <CheatsContext.Provider value={contextState}>{children}</CheatsContext.Provider>
}
